import React from "react";
import Banner from "../components/Banner.js";
import Layout from "../components/Layout.js";

export default function Home() {
  return (
    <Layout className="container-fluid">
      <Banner />
    </Layout>
  );
}
